import { CondensedSearchButton } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/CondensedSearchButton/CondensedSearchButton";

export { CondensedSearchButton };
